import React from "react";
import {
  CaseMigrationStrategy,
  CaseMigrationStrategyLabels
} from "../../models/OrganizationConfiguration/CaseMigrationStrategy";

import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";

interface CaseMigrationStrategySelectProps {
  value: CaseMigrationStrategy[];
  onChange: (value: CaseMigrationStrategy[]) => void;
  disabledCaseTypeSelection?: boolean;
  disabledDateTypeSelection?: boolean;
  disabled?: boolean;
  /** Offer All Cases only; a stored Custom then shows as All Cases, which is what it amounts to. */
  hideCustom?: boolean;
}

const CaseMigrationStrategySelect: React.FC<CaseMigrationStrategySelectProps> = ({
  value,
  onChange,
  disabledCaseTypeSelection,
  disabledDateTypeSelection,
  disabled = false,
  hideCustom = false,
}) => {
  const handleCaseToggleChange = (
    selectedValue: string,
  ) => {
    if (!selectedValue) return;
    const newValues: CaseMigrationStrategy[] = [
      ...value.filter(
        (val) =>
          ![
            CaseMigrationStrategy.AllCases,
            CaseMigrationStrategy.Custom,
          ].includes(val),
      ),
    ];
    newValues.push(selectedValue as CaseMigrationStrategy);
    onChange(newValues);
  };

  const handleDateToggleChange = (
    selectedValue: string,
  ) => {
    if (!selectedValue) return;
    const newValues: CaseMigrationStrategy[] = [
      ...value.filter(
        (val) =>
          ![
            CaseMigrationStrategy.DateAscending,
            CaseMigrationStrategy.DateDescending,
          ].includes(val),
      ),
    ];
    newValues.push(selectedValue as CaseMigrationStrategy);
    onChange(newValues);
  };

  return (
    <div className="flex flex-col gap-2 py-2">
      <ToggleGroup
        type="single"
        disabled={disabled || disabledCaseTypeSelection}
        className="w-full min-h-[45px]"
        value={
          hideCustom
            ? CaseMigrationStrategy.AllCases
            : value
              .filter((val) =>
                [
                  CaseMigrationStrategy.AllCases,
                  CaseMigrationStrategy.Custom,
                ].includes(val),
              )
              .at(0) || ""
        }
        onValueChange={handleCaseToggleChange}
      >
        <ToggleGroupItem value={CaseMigrationStrategy.AllCases} className="flex-1">
          {CaseMigrationStrategyLabels[CaseMigrationStrategy.AllCases]}
        </ToggleGroupItem>
        {!hideCustom && (
          <ToggleGroupItem value={CaseMigrationStrategy.Custom} className="flex-1">
            {CaseMigrationStrategyLabels[CaseMigrationStrategy.Custom]}
          </ToggleGroupItem>
        )}
      </ToggleGroup>
      <ToggleGroup
        type="single"
        disabled={disabled || disabledDateTypeSelection}
        className="w-full min-h-[45px]"
        value={
          value
            .filter((val) =>
              [
                CaseMigrationStrategy.DateAscending,
                CaseMigrationStrategy.DateDescending,
              ].includes(val),
            )
            .at(0) || ""
        }
        onValueChange={handleDateToggleChange}
      >
        <ToggleGroupItem value={CaseMigrationStrategy.DateAscending} className="flex-1">
          {CaseMigrationStrategyLabels[CaseMigrationStrategy.DateAscending]}
        </ToggleGroupItem>
        <ToggleGroupItem value={CaseMigrationStrategy.DateDescending} className="flex-1">
          {CaseMigrationStrategyLabels[CaseMigrationStrategy.DateDescending]}
        </ToggleGroupItem>
      </ToggleGroup>
    </div>
  );
};

export default CaseMigrationStrategySelect;
